var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFormList === true),expression:"isFormList === true"}],staticStyle:{"height":"100%"}}),_vm._v(" "),(_vm.isFormList === false)?_c('editor-questionnaire-view'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a7d928","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LayoutView.vue
// module id = DLiC
// module chunks = 1